// extracted by mini-css-extract-plugin
export var headerCell = "_3u-1";
export var loadingSpinnerContainer = "_3u-4";
export var rowWrapper = "_3u-3";
export var standaloneTable = "_3u-5";
export var table = "_3u-0";
export var white = "_3u-2";